{
  "name": "business-card",
  "version": "3.2.4",
  "description": "Yevhen Fabizhevskyi's personal website.",
  "homepage": "https://fabasoad.github.io/business-card/",
  "scripts": {
    "build:dev": "vite build --mode development",
    "build:prod": "vite build",
    "lint": "biome lint --write src",
    "start:dev": "vite",
    "start:web": "PUBLIC_PATH=../dist nodemon --watch ./server server/app.js",
    "test": "vitest run --coverage --reporter=json --outputFile=vitest-report.json",
    "clean": "rm -rf coverage && rm -rf temp",
    "clean:unsafe": "rm -f package-lock.json && rm -rf node_modules"
  },
  "bugs": {
    "url": "https://github.com/fabasoad/business-card/issues",
    "email": "fabasoad@gmail.com"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/fabasoad/business-card.git"
  },
  "author": {
    "name": "Yevhen Fabizhevskyi",
    "email": "fabasoad@gmail.com",
    "url": "https://github.com/fabasoad"
  },
  "license": "ISC",
  "devDependencies": {
    "@biomejs/biome": "~2.5.11",
    "@testing-library/dom": "~10.4.1",
    "@testing-library/jest-dom": "~7.0.1",
    "@testing-library/react": "~16.3.3",
    "@types/node": "~26.4.0",
    "@types/react": "~19.2.18",
    "@types/react-dom": "~19.2.5",
    "@vitejs/plugin-react": "^6.1.1",
    "@vitest/coverage-v8": "~4.1.11",
    "bootstrap": "~5.3.8",
    "express": "~5.2.1",
    "express-rate-limit": "~8.7.0",
    "humanize-duration": "~3.34.1",
    "i18next": "~26.4.0",
    "jsdom": "~30.0.1",
    "nodemon": "~3.1.14",
    "react": "~19.2.8",
    "react-dom": "~19.2.8",
    "react-i18next": "~17.0.12",
    "sass": "~1.103.1",
    "typescript": "~7.0.2",
    "vite": "~8.2.2",
    "vitest": "~4.1.11"
  },
  "dependencies": {
    "@octokit/rest": "~22.0.1",
    "@tanstack/react-query": "~5.102.8",
    "posthog-js": "~1.422.5",
    "react-bootstrap": "~2.10.10"
  },
  "allowScripts": {
    "@parcel/watcher@2.5.6": true,
    "core-js@3.49.0": true,
    "fsevents@2.3.3": true
  }
}
